/**
 * This helper method removes the ending forward slash form a url and returns the url.
 * @param {string} url - The url to parse.
 * @returns {string} url
 */
export const trimEndForwardSlashForURL = (url: string): string =>
  url && url.endsWith("/") ? url.slice(0, url.length - 1) : url;

export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return "";
  }

  phoneNumber = phoneNumber.trim();

  const correctLength = phoneNumber.length === 10;
  const correctChars = /^\d+$/.test(phoneNumber);

  if (!correctLength || !correctChars) {
    // don't format phone numbers we aren't expecting
    return phoneNumber;
  }

  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

/**
 * Simple hash function for a string
 * @param {string} str - The string to hash.
 * @returns {number} hash
 */
export const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const hashStringSHA256 = async (data: string): Promise<string> => {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};